import React from 'react';
import { motion } from 'framer-motion';
import { materialImage } from '../data/products';
const specs = [{
  label: 'Fibre',
  value: "Modal"
}, {
  label: 'Construction',
  value: 'Knit, single jersey'
}, {
  label: 'Weight',
  value: '180gsm'
}, {
  label: 'Skin',
  value: 'Hypoallergenic, breathable'
}, {
  label: 'Colour',
  value: 'Colourfast, wash after wash'
}, {
  label: 'Manufactured in',
  value: 'Tiruppur, Tamil Nadu'
}];
export function Materials() {
  return <section id="materials" className="border-t border-greige/70 bg-parchment" data-id="element-152" data-mp="1gg9i3p1k36a9">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-6 py-24 lg:grid-cols-2 lg:gap-24 lg:px-12 lg:py-32" data-id="element-153" data-mp="1ge6iqeeik0sv">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-154" data-mp="1qep9lt4hwhka">
          <img src={materialImage} alt="Macro detail of teal modal knit jersey folding in soft daylight" className="aspect-[3/4] w-full object-cover" loading="lazy" data-id="element-155" data-mp="xnxgj4iq8916" />
        </motion.div>

        <div data-id="element-156" data-mp="15ratb8kwoytb">
          <p className="eyebrow text-clay" data-id="element-157" data-mp="15r2gfgos9ti4">Material</p>
          <h2 className="mt-4 font-display text-4xl font-light leading-tight text-ink lg:text-5xl" data-id="element-158" data-mp="1alf27xdqfgx1">
            One fibre.
            <br data-id="element-159" data-mp="1ekxk0ka9bbvn" />
            Knitted, never woven.
          </h2>
          <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-smoke" data-id="element-160" data-mp="hwhu2n38j0i0">
            Everything we make is modal fibre and nothing else. Spun from beech pulp, it is finer
            than cotton, cool against the skin and almost weightless. It is gentle on skin —
            breathable, non-irritating and safe for the most sensitive wearers — and it is built to
            last: the knit holds its shape and the colour holds its depth, wash after wash, year
            after year.
          </p>
          <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-smoke" data-id="element-161" data-mp="27935j994x4wj">
            We knit it as a single jersey so the cloth moves with the body rather than holding a
            shape against it — the reason every top is cut as a tee, with no collar, buttons or
            pockets to press against you while you sleep.
          </p>

          <dl className="mt-10 divide-y divide-greige/80 border-y border-greige/80" data-id="element-162" data-mp="c7hls52ltf6r">
            {specs.map(spec => <div key={spec.label} className="flex items-baseline justify-between py-4" data-id="element-163" data-mp="3kmrtptt6demg">
                <dt className="eyebrow text-ink" data-id="element-164" data-mp="3fnydvuqf1bj4">{spec.label}</dt>
                <dd className="text-sm font-light text-smoke" data-id="element-165" data-mp="3fprnniwbsbvc">{spec.value}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}